module.exports = __webpack_public_path__ + "img/Flake.e7c6dfa7.svg";